import type { AppConfig } from '../types/app-config.types';
import type { AppConfigSource } from '../types/app-config-source.types';
import { mapRawConfigToAppConfig } from '../utils/map-raw-config-to-app-config.util';

export class AppEnvAdapter implements AppConfigSource {
	public read(): AppConfig {
		if (typeof globalThis === 'undefined') {
			return {};
		}

		const runtimeGlobal = globalThis as typeof globalThis & {
			__APP_ENV__?: Record<string, unknown>;
		};

		return mapRawConfigToAppConfig(runtimeGlobal.__APP_ENV__ ?? {});
	}
}
